import React, { useState } from 'react';

const PopupModal = ({ isOpen, onClose, onSubmit, value }) => {
    const [selectedValue, setSelectedValue] = useState(value || 'Select');

    const handleSubmit = () => {
        onSubmit(selectedValue); // Call the submit handler with the selected value
        onClose(); // Close the popup
    };

    if (!isOpen) return null; // Do not render anything if the modal is closed

    return (
        <div className="popup-modal">
            <div className="popup-content">
                <h2>Select Followups As Per</h2>
                <select 
                    value={selectedValue} 
                    onChange={(e) => setSelectedValue(e.target.value)}
                >
                    <option value="Select">Select</option>
                    <option value="Booking">Booking</option>
                    <option value="Expense">Expense</option>
                    <option value="2B">2B</option>
                    <option value="2B & Expense">2B & Expense</option>
                    <option value="No Followup">No Followup</option>
                </select>
                <div>
                    <button onClick={handleSubmit}>Submit</button>
                    <button onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
